<template>
  <div :style="{ '--text-color': textColor, '--text-size': textSize + 'px' }">
    <nuxt-link v-if="internalLink" :class="linkClassName" :to="href" @click.native="handleClick"
      >{{ $t(value) }}
    </nuxt-link>
    <a
      v-else
      :class="linkClassName"
      :href="href"
      target="_blank"
      rel="noopener noreferrer"
      @click="handleClick"
      >{{ $t(value) }}</a
    >
  </div>
</template>

<script>
export default {
  props: {
    internalLink: {
      type: Boolean,
      required: false,
      default: false
    },
    href: {
      type: String,
      required: false,
      default: ''
    },
    value: {
      type: String,
      required: true
    },
    textColor: {
      type: String,
      required: true
    },
    textSize: {
      type: Number,
      required: true
    },
    linkClassName: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick() {
      this.$emit('click', { href: this.href });
    }
  }
};
</script>
<style lang="scss" scoped>
a {
  color: var(--text-color);
  font-size: var(--text-size);
}
</style>
